import { createViewSettingsStore } from '@emfit/shared-store';
import { SessionStore } from 'src/stores/SessionStore';
import { ViewSettingsRepository } from './viewSettingsRepository';
import { t } from 'src/services/LocalizationService';

export type FieldLabels = { field1: string; field2: string };

/**
 * What a home calls each device's two free-text fields, such as "Resident"
 * and "Room". Empty means the generic name; a home sets them once
 * organizations arrive.
 */
export const FieldLabelsStore = createViewSettingsStore<FieldLabels>({
  view: 'field-labels',
  defaults: { field1: '', field2: '' },
  repository: ViewSettingsRepository,
  context: () => ({
    userId: SessionStore.userData ? String(SessionStore.userData.id) : null,
  }),
});

export const fieldLabel = (field: 'field1' | 'field2', labels: FieldLabels = FieldLabelsStore.resolved) =>
  labels[field].trim() || (field === 'field1' ? t('Field 1') : t('Field 2'));
